export default __webpack_public_path__ + "static/media/1.d2528790.JPG";